<template>
  <div>
    <RfButtonNew
      type="quaternary"
      class="border-beige-90 text-beige-90 fill-beige-90"
      :disabled="disabled"
      @click="openTestPushDialog"
    >
      <RfOpenInNewIcon class="h-6 w-6" /> Test Push Notification
    </RfButtonNew>
    <v-dialog v-model="testPushDialog" width="500">
      <v-card flat>
        <v-card-title class="headline">Test Push Notification</v-card-title>
        <v-card-text>
          <p v-if="!channel" class="-mt-3 mb-6">
            Before sending a push notification, ensure an admin has
            <router-link
              :to="`/apps/${$route.params.aid}/settings/connectors`"
              class="text-blue-50"
            >
              configured the respective connector
            </router-link>
            in the settings.
          </p>
          <v-select
            v-if="!channel"
            v-model="pushChannel"
            :items="channelTypes"
            label="Push Channel Type"
            itemTitle="text"
            itemValue="value"
            density="compact"
            persistentPlaceholder
            variant="outlined"
          />
          <v-text-field
            v-model.trim="pushToken"
            hideDetails
            density="compact"
            persistentPlaceholder
            variant="outlined"
            label="Device Token / Address"
          />
        </v-card-text>
        <v-card-actions class="modal-card-actions-div">
          <v-btn
            size="large"
            class="cancel-btn"
            variant="outlined"
            width="100"
            @click="closeTestPushDialog"
          >
            Cancel
          </v-btn>
          <v-btn
            size="large"
            variant="flat"
            color="accent"
            width="220"
            :disabled="!pushToken || !pushChannel"
            @click="submitTestPush"
          >
            Send Test Notification
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ApiApps from "@/apis/ApiApps";
import ApiPaths from "@/apis/ApiPaths";
import { useToastsStore } from "@/pinia/toastsStore";
import RfOpenInNewIcon from "../icons/RfOpenInNewIcon.vue";
import RfButtonNew from "../buttons/RfButtonNew.vue";
import { PushChannels } from "@/utils/constants/SegmentsConstants";

export default {
  name: "RfTestPushSender",
  components: { RfOpenInNewIcon, RfButtonNew },
  props: ["path", "channel", "disabled"],
  setup() {
    return {
      toastsStore: useToastsStore(),
    };
  },
  data: () => ({
    testPushDialog: false,
    pushChannel: "apns",
    pushToken: null,
    channelTypes: Object.values(PushChannels),
  }),
  methods: {
    openTestPushDialog() {
      this.testPushDialog = true;
    },
    closeTestPushDialog() {
      this.testPushDialog = false;
    },
    async submitTestPush() {
      this.closeTestPushDialog();

      try {
        const appId = this.$route.params.aid;
        const channel = this.channel || this.pushChannel;
        if (this.path) {
          await ApiPaths.sendTestPush(appId, this.path.id, channel, this.pushToken);
        } else {
          await ApiApps.testPushChannel(appId, channel, this.pushToken);
        }

        this.toastsStore.create({
          type: "success",
          body: `Test push notification successfully sent via ${channel}`,
        });
      } catch (error) {
        this.toastsStore.create({
          type: "error",
          body: error.message || "Failed to send test push notification",
        });
      }
    },
  },
};
</script>
